"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function BatteryUpdate(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M15.5 12c3.03 0 5.5 2.47 5.5 5.5 0 2.86-2.2 5.25-5 5.5v-2.03c1.69-.24 3-1.71 3-3.47 0-1.93-1.57-3.5-3.5-3.5-.17 0-.34.01-.5.04-.78.11-1.48.48-2 1.02-.62.63-1 1.49-1 2.44 0 .54.13 1.04.36 1.5.07.14.14.28.23.41L14 18v4h-4l1.15-1.15c-.43-.55-.75-1.18-.93-1.85-.15-.48-.22-.98-.22-1.5 0-2.13 1.22-3.98 3-4.89.61-.32 1.28-.52 2-.58.16-.02.33-.03.5-.03zM12 1v2h1c1.1 0 2 .9 2 2v6.02c-.71.05-1.38.22-2 .48V5h-3V3H8v2H5v14h4.18c.13.61.36 1.19.68 1.73l-.27.27H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h1V1h6z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = BatteryUpdate;
